module.exports = __webpack_public_path__ + "img/td_ameritradelogo.3961a360.svg";